(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 93218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ Layout_HomepageFooter; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./src/components/Layout/Footer/index.ts + 1 modules
var Footer = __webpack_require__(29192);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Layout/HomepageFooter.tsx







var HomepageFooter = function HomepageFooter() {
  var _theme$palette$care, _theme$palette$care2;

  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
    featured: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          color: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.grey[600],
          fontWeight: 400
        },
        href: "https://www.forbes.com/sites/nextavenue/2019/06/12/ways-to-vet-a-caregiver-or-caregiving-agency/#546bd23a8a7f",
        target: "_blank",
        underline: "none",
        children: "Ways To Vet A Caregiver Or Caregiving Agency"
      }), ' ', "From Forbes. \xA9 2019 Forbes. All rights reserved. Used under license."]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          color: (_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.grey[600],
          fontWeight: 400
        },
        href: "https://www.huffpost.com/entry/senior-care_b_11057736",
        target: "_blank",
        underline: "none",
        children: "Senior Care: Hope for the Best, Prepare for the Worst"
      }), ' ', "From HuffPost. \xA9 2016 Oath Inc.. All rights reserved. Used under license."]
    })],
    isMobile: isMobile
  });
};

/* harmony default export */ var Layout_HomepageFooter = (HomepageFooter);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Layout/index.ts


/***/ }),

/***/ 90683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ FeatureSection_FeatureSection; }
});

// UNUSED EXPORTS: NumberedTile, Tiles

// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/NumberedTile.tsx





var NumberedTile = function NumberedTile(_ref) {
  var description = _ref.description,
      number = _ref.number,
      title = _ref.title,
      link = _ref.link,
      hideNumberBackground = _ref.hideNumberBackground,
      hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop;
  var isMobile = (0,useMediaQuery/* default */.Z)(theme/* theme.breakpoints.down */.rS.breakpoints.down('md'));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    alignItems: !isMobile ? 'flex-start' : 'center',
    container: true,
    sx: {
      gap: {
        xs: theme/* theme.spacing */.rS.spacing(2),
        md: theme/* theme.spacing */.rS.spacing(3)
      }
    },
    direction: isMobile ? 'column' : 'row',
    justifyContent: "center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        backgroundColor: !hideNumberBackground ? theme/* theme.palette.care.red.100 */.rS.palette.care.red[100] : 'unset',
        borderRadius: '50%',
        color: theme/* theme.palette.care.red.400 */.rS.palette.care.red[400],
        fontSize: '36px',
        fontWeight: 'bold',
        height: '50px',
        padding: theme/* theme.spacing */.rS.spacing(1.5),
        textAlign: 'center',
        width: '50px'
      },
      children: number
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      item: true,
      justifyContent: "space-between",
      sm: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "h3",
        sx: {
          textAlign: {
            xs: 'center',
            md: 'left'
          }
        },
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "body1",
        sx: {
          textAlign: {
            xs: 'center',
            md: 'left'
          },
          margin: hideTileDescriptionMarginTop ? theme/* theme.spacing */.rS.spacing(0.5, 0, 3) : theme/* theme.spacing */.rS.spacing(3, 0, 3)
        },
        color: "secondary",
        children: description
      }), link]
    })]
  });
};

/* harmony default export */ var FeatureSection_NumberedTile = (NumberedTile);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/Tiles.tsx



var features = [{
  description: "Set up a pay cadence that works for you, and we'll onboard your employees to save you time.",
  number: 1,
  title: 'Customized payroll process'
}, {
  description: 'We prepare your quarterly and year-end taxes - filed on-time, every time. Guaranteed.',
  number: 2,
  title: 'Tax returns filed automatically'
}, {
  description: 'Contact our award-winning tax, payroll & HR specialists to have your questions answered quickly and accurately.',
  number: 3,
  title: 'Unlimited access to experts'
}];

var Tiles = function Tiles(_ref) {
  var hideNumberBackground = _ref.hideNumberBackground,
      hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    direction: "column",
    "data-testid": "tiles-container",
    children: features.map(function (feature) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection_NumberedTile, {
          number: feature.number,
          title: feature.title,
          description: feature.description,
          hideNumberBackground: hideNumberBackground,
          hideTileDescriptionMarginTop: hideTileDescriptionMarginTop
        })
      }, feature.number);
    })
  });
};

/* harmony default export */ var FeatureSection_Tiles = (Tiles);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/ProportalBulletTile.tsx





var ProportalBulletTile = function ProportalBulletTile(_ref) {
  var description = _ref.description,
      title = _ref.title,
      hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    container: true,
    alignItems: "flex-start",
    direction: "row",
    sx: {
      gap: {
        xs: theme/* theme.spacing */.rS.spacing(1),
        sm: theme/* theme.spacing */.rS.spacing(2),
        md: theme/* theme.spacing */.rS.spacing(3)
      }
    },
    justifyContent: "flex-start",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        backgroundColor: theme/* theme.palette.care.navy.800 */.rS.palette.care.navy[800],
        borderRadius: '50%',
        height: {
          xs: '12px',
          sm: '14px',
          md: '16px'
        },
        marginTop: theme/* theme.spacing */.rS.spacing(0.75),
        width: {
          xs: '12px',
          sm: '14px',
          md: '16px'
        }
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      item: true,
      justifyContent: "space-between",
      xs: 11,
      md: 10,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "h3",
        sx: {
          textAlign: 'left'
        },
        variant: "h3",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        sx: {
          textAlign: 'left',
          margin: hideTileDescriptionMarginTop ? theme/* theme.spacing */.rS.spacing(0, 0, 1.5) : theme/* theme.spacing */.rS.spacing(3, 0, 3)
        },
        variant: "body2",
        color: "secondary",
        children: description
      })]
    })]
  });
};

/* harmony default export */ var FeatureSection_ProportalBulletTile = (ProportalBulletTile);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/ProportalTiles.tsx




var ProportalTiles_features = [{
  description: 'We manage every aspect of household employer tax compliance, from setting up tax account(s) to filing all required returns and managing tax agency correspondence. At tax time, we prep, file, and distribute W-2s to employees and post a client 1040 Packet containing their completed Schedule H along with records of any 1040-ES payments made through our service. When the time comes, we take care of closing down the state tax accounts.',
  title: 'End-to-End Tax Compliance — Guaranteed',
  key: 1
}, {
  description: 'Stay informed with on-demand access to organized tax records, payment details, and reporting tools. Our dashboard makes it easy to track payroll activity, download reports, and monitor compliance status without sifting through paperwork.',
  title: 'Full Financial Transparency in Real-Time',
  key: 2
}, {
  description: 'Our service automates complex payroll tasks—offering flexible payroll options tailored to household employment. Set default payroll amounts and we’ll withhold the correct taxes, and ensure timely direct deposits, and provide employees with access to paystub records. Payroll updates can be made in seconds using our simple online manager tool. Employees with fluctuating hours can also use our TimeTracker app to easily track and submit their hours for approval and automatic processing.',
  title: 'Streamlined Payroll Processing for Household Employees',
  key: 3
}, {
  description: 'Our intuitive online registration process allows clients and their employees to onboard in less than five minutes. If a client is transitioning over to our service, current year payroll records and/or tax forms can be securely uploaded to their registration.',
  title: 'Effortless Client Onboarding',
  key: 4
}];

var ProportalTiles = function ProportalTiles(_ref) {
  var hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    direction: "column",
    "data-testid": "tiles-container",
    paddingLeft: theme/* theme.spacing */.rS.spacing(6),
    sx: {
      paddingLeft: {
        xs: theme/* theme.spacing */.rS.spacing(3),
        md: theme/* theme.spacing */.rS.spacing(6)
      },
      paddingRight: theme/* theme.spacing */.rS.spacing(3)
    },
    children: ProportalTiles_features.map(function (feature) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection_ProportalBulletTile, {
          title: feature.title,
          description: feature.description,
          hideTileDescriptionMarginTop: hideTileDescriptionMarginTop
        })
      }, feature.key);
    })
  });
};

/* harmony default export */ var FeatureSection_ProportalTiles = (ProportalTiles);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/FeatureSection.tsx










var FeatureSection = function FeatureSection(_ref) {
  var title = _ref.title,
      imageSrc = _ref.imageSrc,
      imageAlt = _ref.imageAlt,
      titleOnRight = _ref.titleOnRight,
      hideNumberBackground = _ref.hideNumberBackground,
      hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop,
      _ref$isProportalSecti = _ref.isProportalSection,
      isProportalSection = _ref$isProportalSecti === void 0 ? false : _ref$isProportalSecti,
      description = _ref.description;
  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
    sx: {
      overflow: 'hidden',
      padding: {
        xs: theme/* theme.spacing */.rS.spacing(6, 0),
        md: theme/* theme.spacing */.rS.spacing(10, 2)
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      direction: "row",
      justifyContent: "center",
      children: isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: imageAlt,
          "data-testid": "feature-section-img",
          height: 344,
          layout: "responsive",
          loading: "lazy",
          objectFit: "cover",
          src: imageSrc,
          width: 500
        })
      })
    }), !titleOnRight && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          textAlign: "center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            textAlign: "center",
            variant: "display3",
            children: title
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      direction: "row",
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        md: 6,
        children: !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: imageAlt,
          "data-testid": "feature-section-img",
          height: isProportalSection ? 500 : 352,
          layout: "responsive",
          loading: "lazy",
          src: imageSrc,
          objectFit: "fill",
          width: isProportalSection ? 640 : 512,
          style: {
            borderRadius: 16
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        md: 6,
        sm: 12,
        children: isProportalSection ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [titleOnRight && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            justifyContent: "flex-start",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              item: true,
              xs: 11,
              md: 12,
              marginTop: theme/* theme.spacing */.rS.spacing(isMobile ? 4 : 0),
              sx: {
                paddingLeft: {
                  xs: theme/* theme.spacing */.rS.spacing(3),
                  md: theme/* theme.spacing */.rS.spacing(6)
                },
                paddingRight: theme/* theme.spacing */.rS.spacing(3)
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h2",
                variant: "h1",
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                marginBottom: theme/* theme.spacing */.rS.spacing(3),
                marginTop: theme/* theme.spacing */.rS.spacing(0.5),
                children: description
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection_ProportalTiles, {
            hideTileDescriptionMarginTop: hideTileDescriptionMarginTop
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [titleOnRight && /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            component: "h2",
            textAlign: "center",
            variant: "display3",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection_Tiles, {
            hideNumberBackground: hideNumberBackground,
            hideTileDescriptionMarginTop: hideTileDescriptionMarginTop
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var FeatureSection_FeatureSection = (FeatureSection);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/index.tsx




/***/ }),

/***/ 52927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ homepage_variant1; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 1 modules
var Layout = __webpack_require__(35699);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/hooks/useGTMTracking.ts
var useGTMTracking = __webpack_require__(86229);
// EXTERNAL MODULE: ./src/components/UserProvider/index.ts + 1 modules
var UserProvider = __webpack_require__(44979);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/special-needs.png
/* harmony default export */ var special_needs = ({"src":"/app/hp-vhp/_next/static/media/special-needs.aa5c87a2.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAuklEQVR42mOAAY2UBYwMaMCs6x5ETL98PxOINm66mGnceL7OpO3aXIsJL5TBkrLO2UBJMOA0abv+ynLiy/9mXXf/6xRsdWSAAXmfSk4eBgY9zYzlnpaTX182qj+zECQMlhTTduQR07JTl7KMlGAHKuJlYHDlYGAwEtdx1oQpEBPTcdIQVbcUkTQJMpIw9LaXMAnUlzDwZoco0HFkBiqSBCoSAtKy4nrucpKmwcwMQCCu68rIgAsAFYMlAdCXKrOd+0vSAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Guarantee/Guarantee.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var CheckedDocumentIcon = function CheckedDocumentIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22.24 23.54H5.36a1.19 1.19 0 0 1-1.19-1.19V18a1 1 0 1 1 2 0v3.54h15.26V2.61H6.17v3.86a1 1 0 0 1-2 0V1.8A1.19 1.19 0 0 1 5.36.61h16.88a1.2 1.2 0 0 1 1.19 1.19v20.55a1.19 1.19 0 0 1-1.19 1.19z",
      fill: "#3A94ED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.42 11.66h-5.5a1 1 0 0 1 0-2h5.5a1 1 0 1 1 0 2zm0 3.73h-5.5a1 1 0 1 1 0-2h5.5a1 1 0 0 1 0 2z",
      fill: "#3A94ED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.62 18.55A6.31 6.31 0 1 1 6.6 5.93a6.31 6.31 0 0 1 .02 12.621zm0-10.61a4.31 4.31 0 1 0-.02 8.62 4.31 4.31 0 0 0 .02-8.62z",
      fill: "#3A94ED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m5.06 12.61.99.96 2.7-2.65",
      fill: "#3A94ED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.05 14.57a1 1 0 0 1-.7-.28l-1-1a1 1 0 1 1 1.4-1.43l.29.28 2-2a1 1 0 1 1 1.41 1.42l-2.7 2.64a1 1 0 0 1-.7.37z",
      fill: "#3A94ED"
    })]
  }));
};

CheckedDocumentIcon.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};


var StarIcon = function StarIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.94 22.28a1.78 1.78 0 0 1-.83-.22L12 19.2l-5.19 2.7A1.7 1.7 0 0 1 5 21.76a1.67 1.67 0 0 1-.67-1.67l1-5.76-4.18-4.08a1.72 1.72 0 0 1 .092-2.54 1.69 1.69 0 0 1 .858-.38l5.79-.83 2.6-5.09A1.7 1.7 0 0 1 12 .47a1.7 1.7 0 0 1 1.52.94l2.59 5.12 5.81 1a1.71 1.71 0 0 1 .88 2.94l-4.16 3.9 1 5.92a1.68 1.68 0 0 1-.7 1.67 1.72 1.72 0 0 1-1 .32zm-6-5.22a1 1 0 0 1 .49.13L17.56 20l-1-5.85a1 1 0 0 1 .3-.89L21 9.4l-5.74-1a1 1 0 0 1-.72-.54L12 2.82 9.44 7.87a1 1 0 0 1-.75.54L3 9.23l4.14 4a1 1 0 0 1 .28.89l-1 5.7 5.12-2.68a1 1 0 0 1 .46-.08h-.06z",
      fill: "#3A94ED"
    })
  }));
};

StarIcon.defaultProps = {
  width: "24",
  height: "23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};




var Guarantee = function Guarantee() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    sx: {
      [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
        margin: '120px auto'
      },
      margin: '0 auto 39px auto'
    },
    maxWidth: "lg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        sm: 6,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            alt: "Our happiness guarantee",
            height: 100,
            layout: "intrinsic",
            loading: "lazy",
            src: special_needs,
            width: 100
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            textAlign: "center",
            variant: "h1",
            children: ["We guarantee your", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "happiness and our service"]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        sm: 6,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          sx: {
            padding: '16px 24px',
            textAlign: 'center',
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
              padding: '10px 30px 0 0',
              textAlign: 'left'
            },
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('xl')]: {
              paddingRight: '128px'
            }
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Guarantee_GuaranteeItem, {
            description: "If HomePay doesn't meet your expectations for an all-in-one nanny tax and payroll service during your first six months of use, we'll refund your payments for our services.**",
            serviceIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(StarIcon, {}),
            title: "Happiness guarantee"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            pt: "24px"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Guarantee_GuaranteeItem, {
            description: "We guarantee that your tax returns are filed accurately and on time.***",
            serviceIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckedDocumentIcon, {}),
            title: "Service guarantee"
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var Guarantee_Guarantee = (Guarantee);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Guarantee/GuaranteeItem.tsx




var GuaranteeItem = function GuaranteeItem(_ref) {
  var description = _ref.description,
      serviceIcon = _ref.serviceIcon,
      title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    sx: {
      display: {
        sm: 'inline-flex'
      },
      '& img': {
        marginRight: {
          sm: 12
        }
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
      mdDown: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        marginRight: "12px",
        width: "24px",
        children: serviceIcon
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
      variant: "body1",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
        mdDown: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("b", {
          children: [title, ":"]
        }), ' ']
      }), description]
    })]
  });
};

/* harmony default export */ var Guarantee_GuaranteeItem = (GuaranteeItem);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Guarantee/index.ts


// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_includes.js + 1 modules
var _includes = __webpack_require__(23859);
// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_curry2.js
var _curry2 = __webpack_require__(83707);
;// CONCATENATED MODULE: ./node_modules/ramda/es/includes.js



/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Also works with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */
var includes = /*#__PURE__*/(0,_curry2/* default */.Z)(_includes/* default */.Z);
/* harmony default export */ var es_includes = (includes);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 9 modules
var ui = __webpack_require__(20935);
// EXTERNAL MODULE: ./src/utils/AnalyticsHelper.ts
var AnalyticsHelper = __webpack_require__(10239);
;// CONCATENATED MODULE: ./src/assets/images/child-care.png
/* harmony default export */ var child_care = ({"src":"/app/hp-vhp/_next/static/media/child-care.7ec08373.png","height":121,"width":121,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA5UlEQVR42mOAAUU9F1ZjY09OEPv/yktSDDAgpu3ICKJldJx01PRd3RkYGCTeTN7R/rtpenAhAwMzAwiUpVrzOTg4GJlaOEir6TmbMjAwKF3yNs/8nx4kwMAABn6SDAzulgx8TnpZsdbCzmZ++gyC7ioMMLBnll7iim7jipXdxvwgvqGFo4KXvpMqAwj8v8xu/eu0wP/ne2T+fz4q9u7cSo1OBgZ37dRIWz4GEDizXJXp/0XO7m8nRD68PSj5/+U+6RMMDFksILnGXCtGBhj4f49B7P91BrP/7xl4QfwtUwyZGBgYGADIB0DxW4YZ0QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/senior-care.png
/* harmony default export */ var senior_care = ({"src":"/app/hp-vhp/_next/static/media/senior-care.d4fe1c1b.png","height":80,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAuklEQVR42mMAA00nJgYk8L/FnbHYAiGGACqOTgxajiEwbpUVTJGko+pUO6fcOkunolAjp9qVLk4znQyc1BlgYKGTU/+dIOdfZ/ycn652dXrzOMT5/2Z35y0MMDDHyal2uavT/6M+zn+vBjr/ASr+v93TeRcDAtgw99k7HVkGVHTM1xms8IiPsxYDCMjqwxxiw1Ri5bRwlavzy1tBztYMQLDIxYmFAQTKrRBe+l/kyskABLOdnJkZGBgYAENOPDkwtmReAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/household.png
/* harmony default export */ var household = ({"src":"/app/hp-vhp/_next/static/media/household.fccd9f7b.png","height":80,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAuElEQVR42mMQ03FkZIACMW0nDgYoENd2goszABVpiGk75kjoOsZK6DoFARXKoygCSqpL6Dk6Cao5tknpOy5UtnZSYQACeTNHJgZRTScmsCpGJwkFC6d8BganXCB2ZAADJ2YG21igKjBwMqje5PC/dJXDf+9CxwwGIIhqdWRhULZ2ZAbL8zmZeOQ6Hs5b6LDXPccxmgEI/EqBCnjkIb4Q13EUZWBw8gBidyBWh5oKMV3WGKgIA0B8AACFVCHkWzcWdAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/RightChoice/RightChoice.tsx













var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL,
    HOUSEHOLD_URL = publicRuntimeConfig.HOUSEHOLD_URL;
var RIGHT_CHOICES = [{
  iconSrc: child_care,
  label: 'Child care',
  url: null
}, {
  iconSrc: senior_care,
  label: 'Senior care',
  url: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.seniorCare.relativeURL */.ZY.seniorCare.relativeURL)
}, {
  iconSrc: household,
  label: 'Household',
  url: HOUSEHOLD_URL
}];

var RightChoice = function RightChoice() {
  var choices = RIGHT_CHOICES.map(function (choice) {
    var iconTile = /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        marginBottom: {
          xs: '4px',
          md: '0px'
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* IconTile */.$X, {
        iconSrc: choice.iconSrc,
        label: choice.label
      }, choice.label)
    }, choice.label);

    if (choice.url) {
      var href = es_includes('http', choice.url) ? choice.url : "/".concat(choice.url);
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: href,
        onClick: function onClick() {
          (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
            data: {
              cta_location: 'HomePay VHP',
              cta_text: choice.label
            },
            name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
            pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
          });
        },
        children: iconTile
      }, choice.label);
    }

    return iconTile;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    sx: {
      padding: theme/* theme.spacing */.rS.spacing(8, 0, 8)
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          display: "flex",
          justifyContent: "center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "display3",
            fontSize: [28, 36],
            textAlign: "center",
            mb: 7,
            mt: 0,
            mx: [1, 14],
            lineHeight: "34px",
            children: "The right choice for all\xA0household employers"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          "data-testid": "choices-wrapper",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 2,
          children: choices
        })
      })]
    })
  });
};

/* harmony default export */ var RightChoice_RightChoice = (RightChoice);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/RightChoice/index.ts

// EXTERNAL MODULE: ./src/components/pages/shared/ModalVideo/ModalVideo.tsx
var ModalVideo = __webpack_require__(75652);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
;// CONCATENATED MODULE: ./src/assets/images/nannyhelp-mw.png
/* harmony default export */ var nannyhelp_mw = ({"src":"/app/hp-vhp/_next/static/media/nannyhelp-mw.bf4fefd1.png","height":316,"width":375,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAAuklEQVR42gGvAFD/AJSNfs3Ny+z2/+fv9q6pn5yYkI2NiYqMiwCempLX1tPr9f3r8/rSzL+trquusrGyu8IAztTY2+Dj6/T77fb+m5mYhmZWv7awurm8AOTr8eLq8N/m7Nnf4p+Kd6RzRGhQQaWlpgDN0dXO1Nmzr7GmmJKlg1eum5JwcHWxuLwAv8rTrbC0fmJVmomSXFRqn5yno6mypqyuAHuFjWBnbZyXlaqttZOYpGp5hICMkoWKjiaqcS7aUb5LAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/assets/images/nannyhelp.png
/* harmony default export */ var nannyhelp = ({"src":"/app/hp-vhp/_next/static/media/nannyhelp.fb409595.png","height":474,"width":563,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAAuklEQVR42gGvAFD/AJSNfs3Ny+z2/+fv9q6onpyYkI2NiYqMiwCempLX1tPr9f3r8/rRy7+trquus7Gyu8IAztTY2+Dk6/T77fb9m5iYh2dXv7exubm8AOTr8eLq8N/m7Njf4p+Kd6RzRGhRQaampwDN0dXO1Nmzr7KnmJOlhFmvnJNwcHaxuL0Av8rTrbC0fmJXmomTXVZroZ6oo6qypqyuAHuFjWBnbZyXlqqttZOYpGp6hICMkoWKjSttcUr2wgU5AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/assets/images/check.png
/* harmony default export */ var check = ({"src":"/app/hp-vhp/_next/static/media/check.bc35da54.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAoUlEQVR42k2PPQrCQBCFp7IULG1sbAxeIJOczAuIhY3ZWNhYCCEEjFst3kl29Qp+GzYkDz6Y3Te/EqUmKPRah0aN78BCPpo5OK18JkmYW3AUaHy8YDDL63chKL/4JUU7/nvR2reCiuqzEkSnA8YxdW9jwmNIMOGOcYOzJOF1Mcsya1Oa35r4NNtjD/14wTsuNpkhAzddQgAWnrRtYiUUIiJ/9QhjKZHUcCgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/NannyHelp/NannyHelp.tsx















var NannyHelp = function NannyHelp() {
  var _theme$palette$care2;

  var _useState = (0,react.useState)(false),
      isVisible = _useState[0],
      setVisibility = _useState[1];

  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  var rightImageSrc = isMobile ? nannyhelp_mw : nannyhelp;

  var toggleModalVisibility = function toggleModalVisibility() {
    return setVisibility(function (_isVisible) {
      return !_isVisible;
    });
  };

  var handleVideoButtonClick = function handleVideoButtonClick() {
    toggleModalVisibility();
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'homepayhelps',
        cta_text: 'PlayVideo_Laura'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  var renderFeatureList = function renderFeatureList() {
    return constants/* NANNY_HELP_FEATURES.map */.zQ.map(function (feature) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        style: {
          display: 'flex',
          margin: '0 0 14px 0'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          height: 24,
          width: 24,
          src: check,
          alt: "nanny-image"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          component: "span",
          variant: "body1",
          fontSize: [16, 16, 18],
          ml: 1.5,
          mb: 0,
          children: feature
        })]
      }, feature);
    });
  };

  var renderContentGrid = function renderContentGrid() {
    var _theme$palette$care;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      sx: {
        [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
          margin: '0 auto'
        }
      },
      item: true,
      md: 7,
      sm: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          '& .feature-list-wrapper': {
            display: 'inline-flex',
            margin: '0 auto'
          },
          '& h2': {
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
              fontSize: '36px',
              lineHeight: '42px',
              padding: '0px 50px 40px 0'
            },
            color: theme/* theme.palette.text.primary */.rS.palette.text.primary,
            fontSize: '28px',
            fontWeight: 'bold',
            lineHeight: '34px',
            padding: '40px 0px 32px 24px'
          },
          '& li': {
            listStyleType: 'none',
            marginBottom: '8px',
            paddingLeft: '0px'
          },
          '& p': {
            fontSize: '18px',
            lineHeight: '24px',
            marginBottom: '10px'
          },
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
            borderRadius: '16px',
            height: '442px',
            padding: '56px 0 0 66px',
            textAlign: 'left'
          },
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('xl')]: {
            marginLeft: '70px'
          },
          '& ul': {
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
              fontSize: '18px',
              lineHeight: '24px',
              paddingLeft: '0'
            },
            marginBottom: '10px',
            marginTop: '16px',
            paddingLeft: '0px',
            textAlign: 'left'
          },
          backgroundColor: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.grey[50],
          padding: '0 0 40px',
          textAlign: 'center'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          "data-testid": "nanny-help-heading",
          variant: "h2",
          children: "HomePay helps your nanny, too"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          component: "p",
          children: ["Paying legally helps your nanny\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
            smUp: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
          }), "qualify for:"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          className: "feature-list-wrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            "data-testid": "feature-list",
            children: renderFeatureList()
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* PlayButtonLink */.e3, {
            "data-testid": "watch-story-link",
            onClick: handleVideoButtonClick,
            children: "See how HomePay helped Laura"
          })
        })]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    sx: {
      marginBottom: theme/* theme.spacing */.rS.spacing(3.625),
      padding: theme/* theme.spacing */.rS.spacing(12, 6, 4, 6),
      [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
        backgroundColor: (_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.grey[50],
        padding: 0
      }
    },
    maxWidth: "xl",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      spacing: 0,
      children: [!isMobile && renderContentGrid(), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        sx: {
          '& span': {
            overflow: 'unset !important'
          },
          position: 'relative',
          width: '100%'
        },
        item: true,
        md: 5,
        sm: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
              bottom: 'unset !important',
              left: '-60px !important',
              position: 'absolute',
              right: 'unset !important',
              top: '-48px !important',
              zIndex: 100
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            alt: "Nanny help",
            "data-testid": "nanny-help-right-image",
            height: !isMobile ? 434 : 316,
            layout: isMobile ? 'responsive' : 'intrinsic',
            loading: "lazy",
            src: rightImageSrc,
            width: !isMobile ? 570 : 375,
            style: {
              borderRadius: isMobile ? 0 : '16px'
            }
          })
        })
      }), isMobile && renderContentGrid(), /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo/* default */.Z, {
        dataTestId: "homepage-how-homepay-helps-modal",
        isVisible: isVisible,
        onClose: toggleModalVisibility,
        title: "See how HomePay helps Laura",
        videoUrl: constants/* HOW_HP_HELPS_LAURA_VIDEO_URL */.Lo
      })]
    })
  });
};

/* harmony default export */ var NannyHelp_NannyHelp = (NannyHelp);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/NannyHelp/index.ts

// EXTERNAL MODULE: ./src/components/pages/shared/Help/variant1/index.ts + 2 modules
var variant1 = __webpack_require__(76929);
// EXTERNAL MODULE: ./src/components/pages/homepage/variant1/Layout/index.ts + 1 modules
var variant1_Layout = __webpack_require__(93218);
// EXTERNAL MODULE: ./src/components/pages/shared/Testimonials/index.ts + 3 modules
var Testimonials = __webpack_require__(41771);
;// CONCATENATED MODULE: ./src/assets/images/familydepends-mw.jpg
/* harmony default export */ var familydepends_mw = ({"src":"/app/hp-vhp/_next/static/media/familydepends-mw.5081ac17.jpg","height":316,"width":375,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAcACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAABP/aAAwDAQACEAMQAAAApgdP/8QAHhAAAgEDBQAAAAAAAAAAAAAAAQIDAARxBREhMTL/2gAIAQEAAT8A1K+hKzq8HuE8MewMb5r/xAAZEQEAAgMAAAAAAAAAAAAAAAACABEDITH/2gAIAQIBAT8Ayk2ddNz/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQMSgf/aAAgBAwEBPwCFuun/2Q==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/assets/images/familydepends.png
/* harmony default export */ var familydepends = ({"src":"/app/hp-vhp/_next/static/media/familydepends.50fd572c.png","height":580,"width":580,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABAUlEQVR42gWAzUrCcADA/+8U9BIdunrJW5Qe6hwYzGhgoR4U8xBqSGYZfrSy0HBlilEqaH6QYc6J5oqRPcF+ISa6Zs2nE3JKHOnAQbddR2/Vybi22LUtWcIw5rwVL3lJeGlUCgz6LcadDp3jIIG1ZcSPadJ/umWkRJn2mjRVhepZHPNrRkZ2IBaLPz6HOo3HB8YfPfThO/VsEtOYoVUvEN/mL4OBRjaV47VWpla4Ix/ykgx6OAlICJtzE7X8TLtaw729QezIR7eichOQ2bevIqKnUfzxe1KRK3xyDNdhmFJR4Tp9TlpaR4xGfStfUnGHE8ihBM6dCEnJRc7vYc++Yv0DVn/ET0dDJ6IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Reviews.tsx









var Reviews = function Reviews() {
  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  var imageURI = isMobile ? familydepends_mw : familydepends;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    sx: {
      padding: theme/* theme.spacing */.rS.spacing(12, 7, 2.5, 11),
      [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
        padding: 0
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Testimonials/* default */.Z, {
      title: "Families depend on HomePay",
      imageURI: imageURI,
      reviews: constants/* reviews */.A9
    })
  });
};

/* harmony default export */ var variant1_Reviews = (Reviews);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./src/assets/images/headset.png
var headset = __webpack_require__(68796);
// EXTERNAL MODULE: ./src/components/pages/shared/EnrollmentCTA/EnrollmentCTA.tsx + 1 modules
var EnrollmentCTA = __webpack_require__(676);
;// CONCATENATED MODULE: ./src/components/pages/shared/GetStarted/variant2/GetStarted.tsx










var GetStarted = function GetStarted(_ref) {
  var _theme$palette$care, _theme$palette$care2, _theme$palette$care3, _theme$palette$care4;

  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      heroImageUri = _ref.heroImageUri;
  var isMobile = (0,useMediaQuery/* default */.Z)(theme/* theme.breakpoints.down */.rS.breakpoints.down('md'));

  var handlePhoneClick = function handlePhoneClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Main VHP - Phone Banner',
        cta_text: "".concat(constants/* PHONE_LABEL */.el)
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
    disableGutters: true,
    maxWidth: false,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      sx: {
        alignItems: 'center',
        background: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.red[100],
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        padding: theme/* theme.spacing */.rS.spacing(0.5)
      },
      width: "100%",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        alt: "Claim Exclusive Offer",
        height: 40,
        src: headset/* default */.Z,
        width: 40
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "body3",
        children: "Claim Exclusive Offer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          margin: theme/* theme.spacing */.rS.spacing(0, 0.5),
          fontWeight: 700
        },
        "data-testid": "phone-number-link",
        onClick: handlePhoneClick,
        href: constants/* PHONE_LINK */.v,
        rel: "nofollow",
        underline: "none",
        children: constants/* PHONE_LABEL */.el
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      sx: {
        background: ((_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.navy)[900],
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
          marginBottom: theme/* theme.spacing */.rS.spacing(-6.25)
        },
        overflow: 'visible'
      },
      disableGutters: true,
      maxWidth: false,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        sx: {
          paddingLeft: 0,
          paddingRight: 0
        },
        container: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              paddingLeft: theme/* theme.spacing */.rS.spacing(2),
              [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
                paddingLeft: 0
              }
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
              sx: {
                [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
                  padding: theme/* theme.spacing */.rS.spacing(8, 4, 8)
                },
                [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
                  padding: theme/* theme.spacing */.rS.spacing(2)
                }
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                  color: (_theme$palette$care3 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care3 === void 0 ? void 0 : _theme$palette$care3.white,
                  margin: theme/* theme.spacing */.rS.spacing(0, 'auto'),
                  paddingTop: 0,
                  textAlign: 'left',
                  [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
                    paddingTop: theme/* theme.spacing */.rS.spacing(1.5),
                    textAlign: 'center'
                  }
                },
                variant: isMobile ? 'serifHeadline2' : 'serifDisplay2',
                children: heading
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                  color: (_theme$palette$care4 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care4 === void 0 ? void 0 : _theme$palette$care4.white,
                  fontSize: '28px',
                  letterSpacing: '0.5px',
                  lineHeight: '34px',
                  margin: theme/* theme.spacing */.rS.spacing(2.5, 'auto', 1.875, 0),
                  width: '82%',
                  [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
                    fontSize: '18px',
                    lineHeight: '24px',
                    marginLeft: 0,
                    textAlign: 'center',
                    width: '100%'
                  }
                },
                variant: isMobile ? 'body1' : undefined,
                children: subHeading
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(EnrollmentCTA/* default */.Z, {
                ctaLocation: "HomePay VHP Variant 2 Hero",
                pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
              })]
            })
          })
        }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          sx: {
            overflow: 'visible',
            position: 'relative'
          },
          item: true,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              [theme/* theme.breakpoints.down */.rS.breakpoints.down('lg')]: {
                'clip-path': 'circle(75% at 75% 70%)'
              },
              height: 450,
              width: '100%',
              'clip-path': 'circle(85% at 75% 57.5%)'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: heroImageUri,
              width: 800,
              height: 450,
              layout: "fill",
              objectPosition: "right",
              objectFit: "cover",
              "data-testid": "hero-image",
              quality: 100
            })
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var variant2_GetStarted = (GetStarted);
;// CONCATENATED MODULE: ./src/components/pages/shared/GetStarted/variant2/index.ts

;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/Hero.tsx




var Hero = function Hero() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_GetStarted, {
    heading: "Pay your nanny legally, save time and money",
    subHeading: "Let our HomePay experts handle your household tax and payroll needs.",
    heroImageUri: nannyhelp
  });
};

/* harmony default export */ var variant2_Hero = (Hero);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallCalculator.js
var IconIllustrationSmallCalculator = __webpack_require__(73103);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/utils/svgIconProps.js
var svgIconProps = __webpack_require__(38423);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/utils/generateStyles.js
var generateStyles = __webpack_require__(46662);
;// CONCATENATED MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallNannies.js




/**
 * IconIllustrationSmallNannies SVG icon component
 */
function IconIllustrationSmallNannies(props) {
    const { sx, className } = props;
    const composedClassName = `${className !== null && className !== void 0 ? className : ''} IconIllustrationSmallNannies`.trim();
    return (react.createElement(SvgIcon/* default */.Z, Object.assign({ sx: [Object.assign({}, (0,generateStyles/* default */.Z)(props)), ...(Array.isArray(sx) ? sx : [sx])], viewBox: "0 0 104 104" }, (0,svgIconProps/* default */.Z)(Object.assign(Object.assign({}, props), { className: composedClassName }))),
        react.createElement("g", { "data-name": "Nannies" },
            react.createElement("path", { fill: "#ffcf0d", d: "M62.59 20.13c.83-3 2.24-6.08 5-7.45a2.76 2.76 0 0 1 1.72-.33 3 3 0 0 1 1.84 1.83 14.5 14.5 0 0 1 .43 10 43 43 0 0 1-4.3 9.25A26.7 26.7 0 0 1 75.06 29a14.08 14.08 0 0 1 8.84-.27 4.2 4.2 0 0 1 2.51 1.78c.78 1.46 0 3.31-1.24 4.47a11.76 11.76 0 0 1-6.81 2.91c-2.5.31-5 .17-7.54.27a21.5 21.5 0 0 1 11.62 10.63 6.9 6.9 0 0 1 .86 3.44 3 3 0 0 1-2 2.67c-1.39.33-2.7-.69-3.74-1.66a88 88 0 0 1-9.81-10.82 57 57 0 0 1 1.14 7.77c.22 3 .09 6.33-2 8.5a3 3 0 0 1-1.41.89c-1.49.35-2.79-1.1-3.42-2.49-1.93-4.28-1.24-9.22-.51-13.86A12 12 0 0 1 45 48.32a2.77 2.77 0 0 1-1.09-.91c-.66-1 .07-2.42.89-3.35a15.28 15.28 0 0 1 14.3-4.75 26.2 26.2 0 0 1-10.69-5.67 9.7 9.7 0 0 1-2.45-3 4.27 4.27 0 0 1-.08-3.74 4.1 4.1 0 0 1 3.14-2 7.9 7.9 0 0 1 3.79.6 15 15 0 0 1 8.56 8.7 43 43 0 0 1 1.22-14.07" }),
            react.createElement("path", { fill: "#172c42", d: "M80.2 83.72c-.12-.25.09-.34-.07-.74-.32-.32-.25-.78-.31-1-.26-.08.17-.36-.43-.18-.16-.66.39-.17.4-.43-.14-.24-.34-.18-.53-.19.2-.12.11-.71-.19-.34-.51-.07.14-1.32-.69-.83.4-.38-.26.16-.06-.37.59.16-1-1.11-.76-.61-.34.49-.13-.62-.46-.35s-.57-.68-.84-.35c-.59 1.14-.21-.93-1-.87.34-.8-.29-.47-.07-1.23.24-.43.19-1.82-.49-1.85.75-.39-.44-1.14-.46-1.8a23.5 23.5 0 0 0-3.21-5.16c-.41-.37-.88-.49-1.25-1.19.56-.14.34.12.15-.35.51.26.18.07.06-.11.41.23.15-.59.49-.28.14 0-.19-.4.13-.18s-.35-.45.09-.12 0-.06-.1-.16c.83.49-.28-.1.61-.37.42.27.31-.09.51 0-.13-.19-.12-.26.08-.11-.37-.75.47.06.19-.43 0 0 .27.21.13 0 .29.28.07-.3.1-.42.17.08.31.24.16-.1.24 0 .24.05.14-.16s.26.18 0-.17c.33-.18.31.07.28-.18s.2 0 0-.3c.1 0 .28.37.21.11.11-.16.8-.13.49-.51.54.24.22-.27.63-.08-.39-.45.51.28.06-.31.48.26.41.38.09-.11.79.54 0-.28.56.22.16-.22-.29-.39.21-.14-.33-.32 0-.45.1-.43.09-.16-.08-.51.4-.37-.23-.43 0 0 .1-.16-.17-.28.18.14.19 0-.29-.43.53.12.19-.7.39.14.35.15.46-.09.12 0 .36.22.18-.1 0-.17.44.32.19-.07.29.27.16 0 .14-.2.29.19.06-.16.24 0-.17-.25.3.24-.08-.23-.22-.26.18.13.15 0 .19.51.24.2 0-.08.46.39.09 0 .06-.22.38.34.56.28.28-.08.32.36.67.1.26-.18-.1-.19.56.35.18-.08h.26c-.47-.69-.13-.3.22-.07-.85-1.21.28.35 0-.17-.4-.56.63.46-.16-.35-.34-.39.85.76.23.08.12-.23.06-.93-1-1.59.46.8.13.26-.35-.09.26.45.35.41-.13.06.51.58-.39-.27-.06.26-.14-.06.38.54 0 .21s.29.52-.05.31c-.14 0-.12 0-.42-.19 0 .24-.17.15-.14.39-.12 0-.31-.14-.15.11-.33-.24-.17 0-.21.23-.2-.14.09.21-.06.1s-.1.23-.21.11c-.35-.15-.4.4-.58.18-.2.19-.11.52-.68.47.24.39-.26.15-.32.4-.21.09-.08.31-.27.19.28.43-.18.17-.14.49-.29-.2 0 .11-.1.14-.26-.06-.21-.41-.28-.82 0 .07-.07.41-.22.19-.29.13.18-.79-.17-.23-.18.19-.09-.36-.33-.43-.09-.32-.57-.28-.29-.68-.49 0-.24-.17-.31-.43-.61.41 0-.25-.13-.25-.52.39 0-.06-.11-.23-.71.16-.84-.65-1-1.35-.38-.06-.07-.29-.44-.18.07-.41-.19-.1-.46-.39 0-.63-.35-.21-.27-.72-.06-.12-.54-.15-.71-.18.18-.16 0 0 0-.06s.14-.34-.1-.26c-.19.23-.1-.19-.28-.16.12-.36-.23.1-.32 0 .15-.3-.51-.33-.51-.42.27-.45-.17 0-.12-.2-.16 0-.11-.32-.29-.12-.09-.07-.6-.62-1-1.1-.45.48-.37-.62-.77-.36-.21-.32-.35-.13-.44-.55-.22-.13-.6.18-.24-.36-.22-.26-.27.85-.4 0 .12-.63-.4.31-.19-.44-.3-.21-.41.39-.4-.25-.5.57-.78-.5-1.2 0-.28-.44-.34-.11-.57-.54-.26.28-.36-.15-.49-.32-.36.42-.46-.68-1.24 0-.18-.44-.33-.43-.62-.49s-.1-.52-.43-.15c-.3-.12-.18-.38-.53-.4-.23.17-.33.16-.4-.06-.06 0-.23.12-.22 0-.21-.27-.15.39-.28.2s.24-.83-.28-.13c-.09-.73-.12.4-.66-.46-.08.22-.1 0-.2.27-.11-.08.15-.65-.16-.33-.59-.51-.33.39-.57.15.09-.13-.17-.4-.13-.24-.14.14-.13.29-.24-.07-.43 0-.21.11-.47.53-.11-.51-.22-1-.26-.21-.26.72.18-1.36-.32-.16-.14-.55 0-.4-.21-.16.13-.78-.28.36-.32-.09a25 25 0 0 1-2-2.33c-.41-.84-1.57-1.15-1.56-2.05-.45-.22.12-.63.15-.07.25.44.58.2.14-.24.52.25.83.23 1-.31-.2-.57.38-.25.43-.91.68 0 1.09-.42 1.55-1 .37-.05.14-.28.59-.25 0-.39.36-.6.39-.79a19.8 19.8 0 0 0 3.78-3.21A4.44 4.44 0 0 0 60.05 35c.47-.65 1.06-.93 1.37-1.53a5.6 5.6 0 0 0 1.93-1.75 7.6 7.6 0 0 0 2-2c1.54-2.92-1.54-6.05-3.55-6.86-.42-.53-1.69-.91-2.18-1.6-.95.14-1.36-.33-2.21-.7A29 29 0 0 0 53 19.7c-.4 0-.7 0-.91-.1-.27.25-.11.22-.45.23a6.7 6.7 0 0 0-2 .09c-1-.29-2.49.1-3.72.26-1.89-.21-4.41.69-6.58 1-.39.25-1.11.09-1.21.49a.73.73 0 0 0-.76.27c0-.1-.39-.18-.43 0a2.84 2.84 0 0 0-1.36.24c-.42.21-.66-.38-1.08.15-.14.37-.43.39-.77.51a2 2 0 0 1-1.15.67c-.18.19-.34.47-.49.65.06.19.36.44 0 .3 0 .4-1.95-.93-3.13-.94-1.36-.13-3.21-.85-4.44-.59-1 .12-2.45-.82-2.86.08-.15-1.38-1.6.11-2.86-.4-.24.17-.78.06-.75.52s-.31-.48-.19.26c-.47.19.2 1.83.64 1.27.21.13.6.13.9.28-.24-.19-.23-.24.06-.42.28.43.48.44.25 0 .28.21.33.11.62.12.44.09.8-.32 1 .14.29-.27.36-.33.68.06 0-.48.23-.35.29 0 .21.12-.06-.59.19-.3 0 .67.48.12.73-.13.21.32.79.33 1 .33a1.45 1.45 0 0 0 1.43.33c.35-.07.64-.1.81.31.06-.13.39-.29.32 0 .16.15.22.06.51.12.09-.09.63-.32.49-.14.15 0 .1 0 .22.21.22-.11.42-.19.61.06-.62 0-.51.15-.34.53 0 .1-.38.93-.17.85.29-.45.25.24 0 .46.61-.25.1.12.29.64a1.4 1.4 0 0 1 0 .94 1.4 1.4 0 0 0 .6.13 1.1 1.1 0 0 0-.46.16c.24.08-.4.27-.17.33.47 0 .24.22-.06.28-.12.2.75-.09.21.21-.78 0 .6.65.17.72a4.2 4.2 0 0 1-.33 1.49 2.9 2.9 0 0 0 .29 1.31.56.56 0 0 1-.26.53c.17.08.35.33.05.32a1.38 1.38 0 0 0 .41 1c-.14 0 0 .12-.23.27.21.21.19.23.2.56-.34.22.25.12.24.29-.31.16.15.74.09.86-.5.11.2.27 0 .54.27.34.06.06.08.4-.11.82.19 1.71.07 2.72.26.36.09.57 0 1 .62.38-.39.44 0 .53.65-.27-.19.7-.05.95.46.26 0 .33.1.5.74.15-.1 1 .53 1.13.09.4 0 .65.08.94s.29.63-.1.88c.26.19.34.32 0 .63.23.3.23.77.59.9a.93.93 0 0 0-.1 1c0 .38-.25.43.13.73-.41.3-.09.25-.13.4-.38.26.49.48.09.8.26.39 0 .39.39.52-.05.38-.94 0 0 .38-.88.36.67.28 0 .59s-.07.51.65.43c-.43.17-.77.4-.73.56.51 0 .38.14 0 .29-.06.19.71-.16.24.18-.65.15.53.52.29 1s.07.81-.21 1.37c0 .24.35.15.06.41.28.06.31.13.09.33.7.17 0 .91.38 1.08.11.24-.37.37 0 .54-.1.24.53.51.35.57 0 .19-.31.29.14.49-.08.38-.12.55.27.52a.69.69 0 0 0 .27.84c-.45.29-.05.21-.07.37.15.22-.13.44.34.36-.49.41.12 1.09.12 1.87-.21.2.21.14.3.22a1.16 1.16 0 0 0 0 .76 2.35 2.35 0 0 1 .39 1.24c.48.27.25.22.07.64.29-.16.58-.46.33.06.22.32 0 .81.52.9.21-.27.09.29.07.37a.49.49 0 0 1 .57.12 1.14 1.14 0 0 0 1 .68c.34.36.41.64.92.68 0 1-.77.26-.36 1.09-.27-.41-.49-.65-.35-.18-.18.12-.5-.49-.11.13-.69-.53 0 .34-.52.33s-.1 0-.25.15-.61-.12-.43.09-.3-.15 0 .21c-.41-.13 0 .12-.16.33s-.5-.14-.23.18c0 .06-.34-.13-.14 0-.45-.23.13.63-.1.45s0 .06 0 .07-.17-.06-.25 0 .35.25.06.21c-.16.18-.17 0 0 .23.32.17-.31 0 0 .19-.32.2.12.16-.3.25.38.09-.29.16.25.35a.38.38 0 0 0-.45.48c-.49.25.06.13 0 .33-.54.08 0 .4-.45.46.58.13-.61.1.13.31-.54.1-.58 0 0 .15-.83 0 0 .25-.58.21 0 .24.49.2-.08.25.4.1.28.36.19.46s.27.18.15.36c-.29 0 .13.07 0 .11-.33-.06 0 .09-.25.12.47.17 0 0 0 .2.32.1-.23 0-.17.09.63.14-.22.18 0 .27-.09.14.13.34.31.42-.36.16-.32.14-.27.41-.12.06-.43.08-.06.2.15.1-.47.09-.17.16s-.09 0-.18.07c.19.15.37.21.11.29-.34-.2-.57.26-1 .07-.35-.41-.09.64-.49.13s.09.75-.37 0a.09.09 0 0 0-.12-.12c-.39.73-1 .64-1.74.93-.14.39-1.14.17-1.27.76.25.24-.36.17-.29.38.24.14 0 .36-.25.4.19.63-.37 1.48-.57 1.82s.22 1 .08 1.26c.11.22-.38.33.06.63-.29.58.05.58.17.86a5.55 5.55 0 0 0 4 4.72c.39.06.74.72 1.15.24.34.32.34.83.34 0 .19 0 .36.39.63.43s.09-.64.33-.05c.4.48.43-.38.84 0 .27-.28 1.53-.18 1.74-.75.59-.1 1.12 0 1.34-.56.48-.15 1-.16.85-.61.89-.13 1-1.09 1-1.55a1.39 1.39 0 0 0 .7-1.17c.31-.23.37-.37.22-.74.72-.49.27-1.75.41-2.34-.38.09-.43 0-.23-.34-.14-.45.64.51.25-.16-.44-.33-.36 0-.27-.54-.89 0-.19-.52-.61-1a2.5 2.5 0 0 0-.69.36c.45-.38.64-.71.17-1.12s-.56.44-.6-.32c.17-.5-.48.24-.3-.47-.47-.46-1.32.45-.6-.71-.54-.15-.55.73-.86.25.05-.31 1.16-.35.49-.64-.72.44-.15-.21-.42-.24-.09.09-.51.7-.41.33.78-1.1-.28.14-.78-.84-1.29.39-.23-.31-.58-.64.29-.27.07-.68.23-.72-.35-.16-.14 0-.2-.33.17-.14 0-.25 0-.37-.18-.15.36-.13 0-.26 0-.18.38 0 .11-.31.27 0 .16-.19.17-.33s.1-.19 0-.33c.13 0 .23-.12.13-.3.35 0 .1-.18.23-.33a.86.86 0 0 0 .39-.74c.23 0 .17-.26.17-.34s.23 0 0-.2c.1-.16.21.09.33-.16s.39-.27.25-.47c.11 0 .27.08.06-.16.24 0 .11-.07.18-.17a.55.55 0 0 1 .37 0c.16-.24.18-.28.52 0-.15-.58.13-.26.22-.65.09-.07.21.25.23.06.21-.44 0-1.09.83-1.11.27.52.45.52 1 .62.19.35.28.33.65.21.11.51.17.2.32.31 0 .47.56-.2.75.18 0 .12.41 0 .4 0 .22.63.05-.29.34-.13.12.2-.24.91.27.25.07-.09.24.66.32 0 .45-.12.62 1 .84-.07 0 .35.38.7.43.41.26-.46.12.4.33.23 0-.77.16.63.87-.32.34.51 1 .18 1.35.72.44.26.75-.24 1 .18.39-.58.89.22 1.21 0 .24.46.8 0 1.11 0 .12 0 .26.37.51 0 .58.4.39-.07.67-.07.32.29.77-.21 1 .22.12-.38.51.22.59-.34 0 .31 1.85.67 2.08.24a2 2 0 0 0 1.58.2c.24.67.52-.28.77.26 0 .64 0-.37.13-.23.27.33.76.56 1.05.32-.07-.34.26.1.29.18a.44.44 0 0 1 .42-.35c.58.27.75-.21 1.19-.1a1 1 0 0 1 .73.1c.21-.44.34.21.52-.15.08 0 .14.16.18.21.19.24.1-.56.35-.1a1 1 0 0 0 1.24-.33 1.83 1.83 0 0 0 1.74.13c.3.45.21.1.39.17.2.39.53-.42.79 0 .55-.21.36.07.57-.33.36 0 0 1 .36.11.31.28.21.22.47-.21.33.47.6.5.72.05.19.52.14.2.56.36.64-.07 0-.84.6-.15.31-.52.66.37.83-.71.26.61.69.76.31.07.27-.57.38.06.21.47 0 .7.43-.88.44 0 .13.41.13-.34.07-.42 0-.47.23.35.11.51.44.25 0-.84.33-.36.12-.53.63.34.41.46.62-.35.42.28-.07.17.11.29.56 0 .49.21-.46.44.63-.1 0 .92.46 0 .49.12 0 .25.32.28 0 .85.62.54 0 .2-.49.38-.18.43.32-.17-.1.57 0 .49.68.16.59.31-.08.43.73.18 1.19.34.13.21-.68-.14.47.4 0 .31a4.6 4.6 0 0 0-1.36.09c.45 0 .36.09.1.42-.52-.23-.87-.13-.29.18-.44 0-.56.15-.89.4s-.51.8-1.06.68c-.08.45-.11.57-.67.62.38.36.08.44-.27.3-.28.15.56.28.1.37-.85-.46-.13.91-.53.85-.48.6-.66 1-1.18 1.59a3.3 3.3 0 0 0-.23 1.67.83.83 0 0 1-.36.74c.26.24.19.39 0 .53-.13.39.39 1 .31 1.28.31.06-.28.29-.07.44s.29.5.21.74a3 3 0 0 1 .9 1.6c.65.21.86 1 1.84 1.26 1.54.82 2.87.35 4.13.6.07-.9.66.52.57-.06-.32-.61.25-.11.55-.09s0-.66.44-.09c.46.18.32-.55.54-.39.42.13.32.09.42-.31.53-.32 1.28-.48 1.2-1.09.8-.32.72-.82 1.3-1.23.14-.23-.06-.42.35-.39.1-.28-.33-.33.14-.56.52-.69.09-1.26.28-1.93.48-.16-.11-.89.38-1.26.14-.27-.59-.52-.02-.8m-7.75-22.55c.16-.13.08 0 0 .11s-.16-.08 0-.11m-43.7-35.58c-.09 0 0-.1.08-.11s.01.13-.08.11m.55 18.05c0-.08.09-.08.12 0Zm5.76 38.16c.95-.14.5.13 1.36-.27 0 .85.77 1.19 1.18 1.88l.43-.35c-.36.35-.54.67-.18.76s.24.29.29.37c.33 0 .09 0 0 .22.35.61-.65 1.81-.46 2.62-1.15 1.7-2.43 2.85-4.26 2.66-.65.24-1.43-.24-2.39-.24a4.8 4.8 0 0 1-1.55-1.09c-2-2.14-.89-7 1.55-6.81.75-.18 1.06-.43 1.68 0 .41-.5.76-.36 1.4-.24.34-.2.27.17.47.3s.48-.15.48.19M56.74 50c0 .57.25-.1.44.17.18 0 .3-.28.31 0 .2.17.43-.14.43.19.23 0 .35.11.56.32.19-.12.38-.24.37.08a7.8 7.8 0 0 1 2.59 1c.12.2.14 0 .25-.09 0 .2 0 .15.16.22.07-.36.62.15.75.26s.54-.08.61.26c.07.09.52-.22.23.19a12 12 0 0 1 2.49 1.5 7.9 7.9 0 0 0 2.26 1.92c.14.3.37.88.84 1 0 .29.17.33.37.34-.08.16 0 .37.16.18.64.45.62 1.75 1.44 1.5-1.12.52 1.28 1.76 1.23 2.32a6.25 6.25 0 0 0-2 1.62c.08.16-.41-.16-.1.15 0 .12-.23 0-.18.08s-.26.37-.4.22c0 .17-.41.4-.35.41-.54-.36-.29.1-.26.31-.12.09-.31.14-.22.42-.36.26-.52-.74-1-.89-.84-.87-1.24-1.68-2-2.55a10.6 10.6 0 0 0-2.39-2.72 8.7 8.7 0 0 0-2-2.48c-.81-.59-1.07-2.15-2-1.77a3.5 3.5 0 0 1 .5-.42c-.4 0-.06-.14-.2-.38-1.14-.46-1.39-1.6-2.28-2.74-.18.27-1.1-.49-.61-.62m.14 3.5s-.13.1-.1 0 .05.02.1.03ZM60 32.29s-.11-.08 0-.12.06.06 0 .12m-25.86-7c-.25-.06-.29-.13-.16-.4.15.2.7.2.33 0s.31-.13.41-.28c.4-.09.56-.59.93-.24.16-.35.21-.42.62-.15-.1-.2 0-.55.17-.23.3.54-.12-.73.39.13.41-1 1.6-.4 2.45-.62.27 0 .79-.77 1.34-.25.13-.41.3-.17.49-.09s.34-.39.64-.37c0-.29 0-.14.11-.08 0-.31.23.25.33.06.11-.52.71.14.63-.5 1.45 0 1.4-.39 2.93-.34.17-.19.4 0 .56 0 .13-.38.15-.31.47-.14.89 0 .9-.21 1.64.07.13-.92.43.62.42 0-.22-.7.67.29 1 .09.23-.62.33.39.48-.16.36-.43.9.34 1.09-.22.48-.14.84.34 1.22 0 .16.22.25.2.43.13.08.43.18.16.31 0a.91.91 0 0 0 1.35.07c.35.44.48.41 1 .43.21.31.26.28.61.14.13.52.15.16.3.28 0 .44.63-.26.72.26.2-.06.34-.1.4.19.09-.2.16-.5.26-.29s-.34.77.26.19c0 .71.19 0 .52 0-.12.93.41.27.64.47 0 .71.4-.48.39.47.29-.58 0 .09.24.18s.75-.3.61-.07c.45.41.78.58 1 1.2.4 0 .16.28.51.14 0 .4.11.11.42.31s-.06.57.43.56c-.25.4.28.47.6.66-.11.06.08.06-.14.29.22.07.4.18.2.42.61 0 .05.43.49.69-.16 0-.51.13-.1.15-.11.22-.31.25.06.43-.43 0-.6.29-1 .78-.63.09-.17.46-.5.53s-1.16.75-1 .91c-.64-.2-.43.3-.64.41-.56-.23-.35-.16-.06.22-.77-.24-.45.39-.94.17-.31.33.12.51-.5.43.54.65-.87.59-.54 1.14-.29.4-.67.42-.91.78.18.33-.9.07-.55.61a.94.94 0 0 0-.92 1c-.58 0-.63.18-.94.57-.36 0-.42.07-.46.41-.45-.08-1.55 1.11-1.17 1.29-.34.24-.67-.78-.43.2-.62-.35-.11.19-.27.44-.4-.31-.84 0-.51.28-.17-.05 0 .13-.45-.12-.07.41-.8.38-.19.78-.29.06-.68-.23-.4.24-.56 0-.62.24-.29.71-.43-.05-1.12-.34-.31.18.09.67-.38 0-.53-.4-.38.19.37 1-.36.36.08.21.14.32.17.39a.45.45 0 0 0-.43-.16c.54.51 0 .44-.29.68 0 .24.11.46-.15.2-1.45-1.82-3.13-3.82-4.53-5.25-.75-.38-1-2.16-1.9-1.85.52-.62-.28-.83-.78-1.42A36.5 36.5 0 0 0 38.52 29c-.51-.55-1-.45-1.54-1.26-.78-.18-.95-.82-1.64-1.23-.42-.57-2.87-1.18-1.17-1.25Zm.76 3.35-.08.08c-.04-.06.04-.14.11-.11Zm-4.39 22.89h.11c.03 0-.16.02-.11 0m40.43 20.06c-.54-.7-.29.14-.74.08a1.66 1.66 0 0 0-1.74-.13c-.27-.3-.25 0-.46 0-.15-.49-.26.13-.52 0-.36.16-.63 0-1 .16-1.26-.35-2.4.11-3.81 0-4.22.54-7.6.26-12.62-.2-.49.2-1-.27-1.73-.25a4.2 4.2 0 0 1-1.3-.16c0 .47-.42-.25-.58.15-.47-.2-.78-.12-1.2-.41a1.39 1.39 0 0 1-1.3-.46c-.62.39-1-.26-1.41 0-.23-.55-1.14-.3-1.35-.72A7.4 7.4 0 0 1 38 68.07c-.33 0-.33-.38-.63-.09a2.7 2.7 0 0 0-1.07-1c-.44-.76-.88-1.64-1.46-2.65-.17-1.78-1-4.31-1.23-6.35a8.2 8.2 0 0 0-.77-2.73 2.1 2.1 0 0 0-.09-1.56c.14-.28 0-.41-.18-.44.22-.07.33-.14.18-.17.06-.18.4-.31 0-.4-.14-.25 0-.58-.27-.58.3-.42-.23-.85.1-1.34a38 38 0 0 1-.65-4.64c-.67-1.62-.48-3.41-1-5.62.22-2.3-.45-5.14-.32-7.85a8.2 8.2 0 0 1-.18-3.06c.2-.28 0-.42-.36-.47.4-.08.71-.23.68-.49a1.07 1.07 0 0 1-.37-1.06 1.58 1.58 0 0 1 0-1.31c-.69-.26.31-.72.17-.41.45.49 1.71.55 2.37 1.32a.83.83 0 0 1 .79.58c.46.13.48 0 .36.53.38-.87.4.37.71.53.52-.14.23.22.4.27.62-.39.61.79 1.09.5.38.17.46.5.69.68s.61.34.45.77c.31 0 .46.06.39.49.37.11.64.51 1 .42.06.76.51 1.06 1 1.58-.25.51.15.08.11.32-.15.4.65.18.54.7.19-.1.32.14.25.35.18-.15.38-.36.37-.12s-.68.49.15.32c-.54.74.71-.12.34.48-.25.83.74 0 .47.9.37-.3.41-.07.18.24.06.24.39-.45.35-.07-.49.67.64.23.71.79.52 1.08.63 1.6 1.57 2.07a.62.62 0 0 1 .12.6c.31 0 .36 0 .27.28.11-.12.07 0 0 .12s.24-.07.28.23c.13 0 .71.15.49.2.15.06.07.09 0 .32.24.05.5.12.47.46.42 0 .46.17.83.6a15.3 15.3 0 0 1 1.69 2c0 .35.15.19.39.18a.9.9 0 0 0 .23.61c.2.43.76.55.61.88.07.44.87.22.26.67 0 .42.41-.45.44-.12s.08 1 .46 1c.21-.28.1.26.06.33A.41.41 0 0 1 52 48c.23.6.66.48.89.88.29.15.51.9.86 1-.29.81.41-.06.25.49a1.13 1.13 0 0 0 1 .79c0 .74.52 1.08 1 1.59-.26.49.16.09.11.32-.15.41.65.19.53.71.29-.18.21.35.3.31s.33-.27.32-.07-.68.47.16.32c-.41.74.7-.21.29.71-.05.33.16.28.46.08.17.56 0 .38.44.52-.17.21-.26.53 0 .18s-.41.6.11.41c.11.12.75 0 .55.22.63.91.73 1.93 1.59 2.19a.59.59 0 0 1 .25.71c.32 0 .36 0 .27.28.12-.12.07 0 .06.12s.24-.07.28.23c.24.05.61.09.49.24.25-.11-.17.54.3.29.28.2.13.67.58.37a6 6 0 0 0 1 1.31c.21-.22.35.94 1 1.15.18.77.46.15.61.87.3.55.82.71.72 1.06s.87.24.24.67c0 .41.42-.44.45-.11-.34.67.44.43.11.8.08.49.53-.11.45.45-.22.27.16 0 .31 0s.26.53.4.48c.13.5.52.18.73.64a3.4 3.4 0 0 0 .74 1c-.39.57.42 0 .19.41a1.11 1.11 0 0 0 1 .85c-.04.71.3.43-.1 1.12m4.34 18c-1.16.1-2.67.72-4.15.4A3.87 3.87 0 0 1 69 85.37c.31-1.36.35-2.79 1.2-3.23.41-.64.68-1.14 1.47-1.16 0-.58.37-.66.7-1s.6-.48 1.1-.3c.44-.9 0 .65.48-.16-.1.67.59.42.77.06.42.15 0 .62.58.25.55 0 .45.8 1.12 1.06.32 0 .67.48.61.76.46 0 .35.49.74.44a24 24 0 0 0 .25 3.19c-.65 2.13-1.14 3.32-2.74 4.32Z" }),
            react.createElement("path", { fill: "#172c42", d: "M25.45 51.62c-.12 0 .12-.58 0-.77-.15.5 0 .53-.15-.05 0 .57-.21-.57-.38.52-.16-.32-.05-.54-.22-.08-.1.25-.81-1-.9-.09-1-.68-3.76.07-5.23.1-1.32-.27-3.68.27-4.39-.07-.23.11-.56.18-.64-.15s-.69.73-1 .27c-.69.08-.33 2.94.26 2 0-.32.09.1.15.19 0-.57.18 0 .59-.42.09.42.18.12.16-.15.18.41.12.44.28.12.09.78 0-.12.11 0 .1.75.21-.34.4 0a4 4 0 0 0 .9.42c.19-.7.63.31.65-.08.36 0 .17-.49.43-.07 0-.38.15-.06.28-.06 0-.45.06-.14.33-.26.15-.29 0 0 .14.11.09-.36.26.13.23-.39 0 .4.46.27.82.3 0-.53.1.2.25 0 .21.28.2-.26.39.15 0-.57.1.26.26 0 .07-.51.19.73.14-.25.27.66.14.09.4.5.14-.28.06-.32.2 0 0-.41.27-.36.38-.28.24-.24.3-.32.57-.09.06-.17.24-.17.3.12.18-.4.44.32.65-.44 0 .23.74.48.66.24.43.51.66-.18.89 0-.19.51.06.31.06-.06.16.74 0-.69.35.31a3 3 0 0 0 .08-.63v.55c.07-.49 0 0 .11.16.51-.06.12-.37.33-.36 0 .29.13.34.12 0 .4.66.27-1.13.42.32.18-.33-.07-.66.12-.84 0 1.47.21.58.23.3 0 .91 0 .35.18 0 .41.9.43-2.44.09-1.09m-1.34 4.86c0 .27 0 .7-.11.37-.05-1.42 0 .31-.18-.64v.15c-.08-.44-.21.09-.45.33a.55.55 0 0 0-.94-.21c-.07-.26 0 .26-.08.06s-.19.11-.21 0-.34-.36-.4 0c-.25-.52-.23.19-.46 0s-.86.17-1 0c-.06.55-.33 0-.44.39-.11-.34-.1.27-.22-.08s-.06.36-.15.07c-.42-.13-1 .12-1.27.11-.84-.12-2-.1-2.45.33-.16-.16-.24-.27-.43-.2s-.35-.71-.52.08c-1.32-.21-.68 2.37-.2 2.35-.13-.78.21.19.11-.47.11.19.58 0 .57-.05s.15.6.12-.07c.13-.09.05.26.11.32 0-.39 0-.41.1 0 .12-1.15.75.45.84-.22.1.21.23-.18.5.05.1.29.2-.12.26-.29.2.48.43-.43.7 0-.05-.37.19.15.12-.38.11.59.14-.1.29.35.06-.28.41.23.37-.29.26.43.43.11.5.09 0 .32.23.3.14 0 .23.51.12.53.11 0 .21.67.18-.06.29.49.19.08 0-.62.17-.13 0 .33 0-.3.15-.25.26.46.27-.54.57 0 0-.17.17-.22.22.1.11-.44.35.33.46-.46 0 .22.6.44.51.21.12.19.13 0 .23.3.1-.44.19-.1.28-.28a.2.2 0 0 0 0 .08c.15-.64.15.69.19-.22.11.56.05.08.14-.13.1.53.18.46.19.2 0 .11 0 .13.05-.06 0 .1 0 .56.09.24.23.45.12-.68.2-.12.16.36 0-.25.14 0 .23.43.06-.54.19-.34.18.84 0 .14.11-.15.07.26.19 1.28.18 0 .17 1.11 0 .27.15.37 0-.36 0-.14.11.08a1.34 1.34 0 0 0 .13-.85c-.01.14.1-1.12-.08-1.23" }))));
}
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./src/assets/images/instant-payment.png
/* harmony default export */ var instant_payment = ({"src":"/app/hp-vhp/_next/static/media/instant-payment.9cdab536.png","height":150,"width":150,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAwElEQVR42mPABhQtnTgZGBwZUQSP/bfl+P/fhP3KfxtuTllHPbjE4ld2bkte2+2ddc9+W+FSh/PJEx126Xk6yjAwOLGCFSx8Yd804YL9/zkP7f+nTnX4D5T4L23oOEFSz9FMTNuJhWH+U/u8zmP2//vP2/+fet3+v12840sGFqcjKjaOFuLaQFPW/7YTmn3ffn/7YfsHZWsdSoGSK2SNHdMxXO6YDLLXWRJDYsZteyYIy4nTr8SRD8QS03JkgckDAIxRP1FIU18jAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronRight.js
var Icon24UtilityChevronRight = __webpack_require__(16178);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/Services/ServiceTile.tsx













var ServiceTile = function ServiceTile(_ref) {
  var description = _ref.description,
      icon = _ref.icon,
      label = _ref.label,
      mobileDescription = _ref.mobileDescription,
      url = _ref.url;
  var isMobile = (0,hooks/* useMobileQuery */.Lh)();

  var handleTileClick = function handleTileClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'HomePay VHP Variant 2 Hero',
        cta_text: label
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    item: true,
    md: 3,
    xs: 12,
    sx: {
      display: 'flex',
      width: '100%'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: url,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          display: 'flex',
          width: '100%'
        },
        href: url,
        onClick: handleTileClick,
        underline: "none",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
          careVariant: "subtle",
          sx: {
            opacity: {
              xs: 0.85,
              md: 1
            },
            width: '100%'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            sx: {
              height: '100%'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              sx: {
                height: '100%'
              },
              container: true,
              direction: isMobile ? 'row' : 'column',
              wrap: "nowrap",
              children: [/*#__PURE__*/(0,react.isValidElement)(icon) ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: icon
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                alt: "Service icon",
                height: 45,
                layout: "fixed",
                src: icon,
                width: 45
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: "column",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  variant: "h3",
                  children: label
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  variant: "body3",
                  color: "secondary",
                  children: mobileDescription && isMobile ? mobileDescription : description
                })]
              }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                sx: {
                  margin: 'auto 0 0 auto'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon24UtilityChevronRight/* default */.Z, {})
              })]
            })
          })
        })
      }, label)
    })
  });
};

/* harmony default export */ var Services_ServiceTile = (ServiceTile);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/Services/Services.tsx









var Services_ref = config_default()(),
    Services_publicRuntimeConfig = Services_ref.publicRuntimeConfig;

var Services_HOMEPAY_URL = Services_publicRuntimeConfig.HOMEPAY_URL,
    NTG_URL = Services_publicRuntimeConfig.NTG_URL,
    SNC_URL = Services_publicRuntimeConfig.SNC_URL;
var SERVICES = [{
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconIllustrationSmallCalculator/* default */.Z, {
    size: 45
  }),
  label: 'Budget & tax calculator',
  description: 'Access our household employer budget and tax calculators',
  mobileDescription: 'Access our household employer tools',
  url: "".concat(Services_HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.nannyTaxCalculator.relativeURL */.ZY.nannyTaxCalculator.relativeURL)
}, {
  icon: instant_payment,
  label: 'Sample nanny contract',
  description: 'Get more money back this tax season',
  url: SNC_URL
}, {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconIllustrationSmallNannies, {
    size: 45
  }),
  label: 'Nanny tax guide',
  description: "Let us handle it so you don't have to",
  url: NTG_URL
}];

var Services = function Services() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    sx: {
      [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
        overflow: 'hidden',
        paddingTop: theme/* theme.spacing */.rS.spacing(3),
        paddingBottom: theme/* theme.spacing */.rS.spacing(1.875)
      },
      position: 'relative'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      sx: {
        zIndex: 20
      },
      "data-testid": "services-container",
      direction: "row",
      justifyContent: "center",
      spacing: 3,
      children: SERVICES.map(function (service) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Services_ServiceTile, {
          description: service.description,
          icon: service.icon,
          label: service.label,
          mobileDescription: service.mobileDescription && service.mobileDescription,
          url: service.url
        }, service.label);
      })
    })
  });
};

/* harmony default export */ var Services_Services = (Services);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/Services/index.ts

;// CONCATENATED MODULE: ./src/assets/images/how-homepay-works.png
/* harmony default export */ var how_homepay_works = ({"src":"/app/hp-vhp/_next/static/media/how-homepay-works.fb0e1022.png","height":344,"width":462,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAAoUlEQVR42gGWAGn/AN3f4OHl5uLn6Nvg4tXW2MvMzrixrMnAuwDo6+zZ2NmzqaewoJzT0tTc3+LWzMPJtKUA0tPUoIuFfFlPjFtHvrWzwcLCsKyiysG6ALG0un92eHJpaYaBg7CgmZWEeKCYk9zg5ADMw8HEubOoiXWnkY2hjIWDbViSg3q+rKMA6Onx3tDJwYU+w5yAqI19hlMSlGZEpHxgi95gjWzAWPAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./src/components/pages/shared/FeatureSection/index.tsx + 5 modules
var FeatureSection = __webpack_require__(90683);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/HowItWorks.tsx



function HowItWorks() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection/* default */.ZP, {
    title: "How it works",
    imageSrc: how_homepay_works.src,
    imageAlt: "How Homepay works"
  });
}
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/index.tsx

















var Homepage = function Homepage() {
  var _useUserAuth = (0,UserProvider/* useUserAuth */.Ii)(),
      auth = _useUserAuth.auth;

  (0,useGTMTracking/* default */.Z)({
    pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP,
    slots: [].concat((0,toConsumableArray/* default */.Z)(auth !== null && auth !== void 0 && auth.isLoggedIn ? [] : constants/* GTM_DATA.nonMember.slots */.cd.nonMember.slots), (0,toConsumableArray/* default */.Z)(constants/* GTM_DATA.mainVHP.slots */.cd.mainVHP.slots))
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.Z, {
    FooterComponent: variant1_Layout/* HomepageFooter */.w,
    sx: {
      paddingLeft: '0 !important',
      paddingRight: '0 !important'
    },
    maxWidth: false,
    meta: constants/* META_PROPERTIES.mainVHP */.b_.mainVHP,
    pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(variant2_Hero, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Services_Services, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorks, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(variant1_Reviews, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RightChoice_RightChoice, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(NannyHelp_NannyHelp, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Guarantee_Guarantee, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(variant1/* default */.Z, {})]
  });
};

/* harmony default export */ var homepage_variant1 = (Homepage);
;// CONCATENATED MODULE: ./src/pages/index.ts


/***/ }),

/***/ 89886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(52927);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16178:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Icon24UtilityChevronRight; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53219);
/* harmony import */ var _utils_svgIconProps_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38423);
/* harmony import */ var _utils_generateStyles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46662);




/**
 * Icon24UtilityChevronRight SVG icon component
 */
function Icon24UtilityChevronRight(props) {
    const { sx, className } = props;
    const composedClassName = `${className !== null && className !== void 0 ? className : ''} Icon24UtilityChevronRight`.trim();
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ sx: [Object.assign({}, (0,_utils_generateStyles_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props)), ...(Array.isArray(sx) ? sx : [sx])], viewBox: "0 0 24 24" }, (0,_utils_svgIconProps_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Object.assign(Object.assign({}, props), { className: composedClassName }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#223f5f", d: "M8 5.79a.91.91 0 0 1 0-1.2.91.91 0 0 1 1.2 0l6.8 6.8a.91.91 0 0 1 0 1.2l-6.8 6.8a.91.91 0 0 1-1.2 0 .91.91 0 0 1 0-1.2L14.2 12Z" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#223f5f", d: "M8.6 19.77a1 1 0 0 1-.71-.27 1.08 1.08 0 0 1 0-1.41L14 12 7.89 5.9a1.08 1.08 0 0 1 0-1.41 1.12 1.12 0 0 1 1.42 0l6.79 6.8a1.06 1.06 0 0 1 0 1.41l-6.79 6.8a1 1 0 0 1-.71.27m0-15.25a.74.74 0 0 0-.5.18.77.77 0 0 0 0 1l6.31 6.3-.1.11L8.1 18.3a.77.77 0 0 0 0 1 .77.77 0 0 0 1 0l6.8-6.8a.7.7 0 0 0 .18-.5.7.7 0 0 0-.18-.49L9.09 4.7a.7.7 0 0 0-.49-.18" })));
}
//# sourceMappingURL=data:application/json;base64,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

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [611,2284,7423,3340,1614,7060,2004,1724,11,9471,5699,1230,8186,9774,2888,179], function() { return __webpack_exec__(89886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);